<template>
  <div v-if="!multipleUsers"
    :class="`iconn_avatar iconn_avatar_${size}`"
    style="display: flex; flex-direction: column; justify-content: center"
  >
    <div v-if="isConnected" :class="`iconn_avatar_connected_${size}`">
      <SvgFactory :width="connectedSize" name="icon_connections" color="white" />
    </div>
    <v-avatar
      v-if="initials"
      class="fill-purple border-purple"
      :class="`iconn_avatar_inner_${size}`"
      :size="singleSize"
    >
      <v-img v-if="profileImg" :src="profileImg" :alt="initials" />
      <span v-else>{{ initials }}</span>
    </v-avatar>
    <v-avatar
      v-else
      class="iconn_avatar_inner--empty"
      :size="singleSize"
    >
      <v-img v-if="profileImg" :src="profileImg" :alt="initials" />
      <SvgFactory v-else name="icon_no_headshot" :width="singleSize" />
    </v-avatar>
  </div>
  <div v-else-if="multipleUsers && userCount === 2 && horizontalStack"
    class="iconn_avatar"
    style="display: flex; flex-direction: column; justify-content: center"
    :style="{ marginRight: horizontalStackMargin }"
  >
    <v-avatar
      style="z-index: 1; top: 0"
      :style="{ right: horizontalStackOffset }"
      class="fill-purple border-purple"
      :class="`iconn_avatar_inner_${size}`"
      :size="mainSize"
    >
      <v-img v-if="users[0].profileImg" :src="users[0].profileImg" :alt="users[0].initials" />
      <span v-else>{{ users[0].initials }}</span>
    </v-avatar>
    <v-avatar
      style="position: absolute"
      class="fill-purple border-purple"
      :class="`iconn_avatar_inner_${size}`"
      :size="mainSize"
    >
      <v-img v-if="users[1].profileImg" :src="users[1].profileImg" :alt="users[1].initials" />
      <span v-else>{{ users[1].initials }}</span>
    </v-avatar>
  </div>
  <div v-else-if="multipleUsers && userCount === 3 && horizontalStack"
    class="iconn_avatar"
    style="display: flex; flex-direction: row"
  >
    <v-avatar
      style="z-index: 0; top: 0"
      class="fill-purple border-purple"
      :class="`iconn_avatar_inner_${size}`"
      :image="users[0].profileImg"
      :size="mainSize"
      :alt="users[0].initials"
    >
      <v-img v-if="users[0].profileImg" :src="users[0].profileImg" :alt="users[0].initials" />
      <span v-else>{{ users[0].initials }}</span>
    </v-avatar>
    <v-avatar
      style="z-index: 1; top: 0"
      :style="{ right: stackOffset(1) }"
      class="fill-purple border-purple"
      :class="`iconn_avatar_inner_${size}`"
      :image="users[1].profileImg"
      :size="mainSize"
      :alt="users[1].initials"
    >
      <v-img v-if="users[1].profileImg" :src="users[1].profileImg" :alt="users[1].initials" />
      <span v-else>{{ users[1].initials }}</span>
    </v-avatar>
    <v-avatar
      style="z-index: 2"
      :style="{ right: stackOffset(2) }"
      class="fill-purple border-purple"
      :class="`iconn_avatar_inner`"
      :image="users[2].profileImg"
      :size="mainSize"
      :alt="users[2].initials"
    >
      <v-img v-if="users[2].profileImg" :src="users[2].profileImg" :alt="users[2].initials" />
      <span v-else>{{ users[2].initials }}</span>
    </v-avatar>
  </div>
  <div v-else-if="multipleUsers && userCount === 2"
    class="iconn_avatar"
    style="display: flex; flex-direction: column; justify-content: center"
  >
    <v-avatar
      class="fill-purple border-purple"
      :class="`iconn_avatar_inner_${size}`"
      :size="mainSize"
    >
      <v-img v-if="users[0].profileImg" :src="users[0].profileImg" :alt="users[0].initials" />
      <span v-else>{{ users[0].initials }}</span>
    </v-avatar>
    <v-avatar
      class="fill-purple border-purple"
      :class="`iconn_avatar_secondary_${size}`"
      :size="secondarySize"
    >
      <v-img v-if="users[1].profileImg" :src="users[1].profileImg" :alt="users[1].initials" />
      <span v-else>{{ users[1].initials }}</span>
    </v-avatar>
  </div>
  <div v-else-if="multipleUsers && userCount === 3"
    class="iconn_avatar"
    style="display: flex; flex-direction: column; justify-content: center"
  >
    <v-avatar
      class="fill-purple border-purple"
      :class="`iconn_avatar_inner_${size}`"
      :image="users[0].profileImg"
      :size="mainSize"
      :alt="users[0].initials"
    >
      <v-img v-if="users[0].profileImg" :src="users[0].profileImg" :alt="users[0].initials" />
      <span v-else>{{ users[0].initials }}</span>
    </v-avatar>
    <v-avatar
      class="fill-purple border-purple"
      :class="`iconn_avatar_secondary_${size}`"
      :image="users[1].profileImg"
      :size="secondarySize"
      :alt="users[1].initials"
    >
      <v-img v-if="users[1].profileImg" :src="users[1].profileImg" :alt="users[1].initials" />
      <span v-else>{{ users[1].initials }}</span>
    </v-avatar>
    <v-avatar
      class="fill-purple border-purple"
      :class="`iconn_avatar_secondary_${size}_second`"
      :image="users[2].profileImg"
      :size="secondarySize"
      :alt="users[2].initials"
    >
      <v-img v-if="users[2].profileImg" :src="users[2].profileImg" :alt="users[2].initials" />
      <span v-else>{{ users[2].initials }}</span>
    </v-avatar>
  </div>
  <div class="iconn_avatar_group" :class="`iconn_avatar_group_${size}--container`" v-else-if="multipleUsers && userCount >= 4">
    <div class="iconn_avatar_group--item">
      <div>
        <v-avatar
          class="fill-purple border-purple"
          :class="`iconn_avatar_group_${size}`"
          :image="users[0].profileImg"
          :size="groupSize"
          :alt="users[0].initials"
        >
          <v-img v-if="users[0].profileImg" :src="users[0].profileImg" :alt="users[0].initials" />
          <span v-else>{{ users[0].initials }}</span>
        </v-avatar>
    </div>
    </div>
    <div class="iconn_avatar_group--item">
      <div>
        <v-avatar
          class="fill-purple border-purple"
          :class="`iconn_avatar_group_${size}`"
          :image="users[1].profileImg"
          :size="groupSize"
          :alt="users[1].initials"
        >
          <v-img v-if="users[1].profileImg" :src="users[1].profileImg" :alt="users[1].initials" />
          <span v-else>{{ users[1].initials }}</span>
        </v-avatar>
      </div>
    </div>
    <div class="iconn_avatar_group--item">
      <div>
        <v-avatar
          class="fill-purple border-purple"
          :class="`iconn_avatar_group_${size}`"
          :image="users[2].profileImg"
          :size="groupSize"
          :alt="users[2].initials"
        >
          <v-img v-if="users[2].profileImg" :src="users[2].profileImg" :alt="users[2].initials" />
          <span v-else>{{ users[2].initials }}</span>
        </v-avatar>
      </div>
    </div>
    <div class="iconn_avatar_group--item">
      <div>
        <div
          class="fill-purple border-purple"
          :class="`iconn_avatar_group_${size}`"
        >
        {{ moreText }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SvgFactory from '@design_system_v2/atoms/SvgFactory.vue';

export default {
  name: 'AvatarComponent',
  components: { SvgFactory },
  props: {
    size: {
      type: String,
      default: 'md',
    },
    isConnected: {
      type: Boolean,
      default: false,
    },
    initials: {
      type: String,
      default: '',
    },
    profileImg: {
      type: String,
      default: '',
    },
    users: {
      type: Array,
      default() {
        return [];
      },
    },
    horizontalStack: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    stackOffset(index) {
      return `${(0.25 * this.mainSize * index).toString()}px`;
    },
  },
  computed: {
    horizontalStackOffset() {
      return `${((-1 * this.mainSize) / 2).toString()}px`;
    },
    horizontalStackMargin() {
      return `${(this.mainSize / 2).toString()}px`;
    },
    userCount() {
      return this.users.length;
    },
    multipleUsers() {
      return this.userCount > 1;
    },
    mainSize() {
      if (this.size === 'sm' && this.userCount === 2) {
        return 32;
      }
      if (this.size === 'xs' && this.userCount === 2) {
        return 24;
      }
      if (this.size === 'md' && this.userCount === 2) {
        return 48;
      }
      if (this.size === 'lg' && this.userCount === 2) {
        return 56;
      }
      if (this.size === 'xl' && this.userCount === 2) {
        return 64;
      }
      if (this.size === '2xl' && this.userCount === 2) {
        return 128;
      }
      if (this.size === 'sm' && this.userCount === 3) {
        return 32;
      }
      if (this.size === 'xs' && this.userCount === 3) {
        return 24;
      }
      if (this.size === 'md' && this.userCount === 3) {
        return 48;
      }
      if (this.size === 'lg' && this.userCount === 3) {
        return 56;
      }
      if (this.size === 'xl' && this.userCount === 3) {
        return 64;
      }
      if (this.size === '2xl' && this.userCount === 3) {
        return 128;
      }
      return null;
    },
    secondarySize() {
      if (this.size === 'sm' && this.userCount === 2) {
        return 16;
      }
      if (this.size === 'xs' && this.userCount === 2) {
        return 12;
      }
      if (this.size === 'md' && this.userCount === 2) {
        return 24;
      }
      if (this.size === 'lg' && this.userCount === 2) {
        return 24;
      }
      if (this.size === 'xl' && this.userCount === 2) {
        return 32;
      }
      if (this.size === '2xl' && this.userCount === 2) {
        return 56;
      }
      if (this.size === 'sm' && this.userCount === 3) {
        return 12;
      }
      if (this.size === 'xs' && this.userCount === 3) {
        return 8;
      }
      if (this.size === 'md' && this.userCount === 3) {
        return 16;
      }
      if (this.size === 'lg' && this.userCount === 3) {
        return 24;
      }
      if (this.size === 'xl' && this.userCount === 3) {
        return 24;
      }
      if (this.size === '2xl' && this.userCount === 3) {
        return 40;
      }
      return null;
    },
    moreText() {
      return this.userCount >= 4 ? `+${this.userCount - 3}` : '';
    },
    singleSize() {
      switch (this.size) {
        case 'xs':
          return 24;
        case 'sm':
          return 32;
        case 'md':
          return 48;
        case 'lg':
          return 56;
        case 'xl':
          return 64;
        case '2xl':
          return 128;
        default:
          return 48;
      }
    },
    groupSize() {
      switch (this.size) {
        case 'xs':
          return 12;
        case 'sm':
          return 16;
        case 'md':
          return 24;
        case 'lg':
          return 24;
        case 'xl':
          return 32;
        case '2xl':
          return 64;
        default:
          return 24;
      }
    },
    connectedSize() {
      switch (this.size) {
        case 'xs':
          return 2;
        case 'sm':
          return 10;
        case 'md':
          return 18;
        case 'lg':
          return 24;
        case 'xl':
          return 32;
        case '2xl':
          return 38;
        default:
          return 24;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@foundation";

.fill-purple {
  background: map-get($primary, "purple-200");
  color: map-get($primary, "purple-50");
}

.border-purple {
  border-color: map-get($primary, "purple-50");
  @extend .border_rounded_total;
}

.iconn_avatar {
  position: relative;

  &_2xl {
    @extend .height_7xl;
    @extend .width_7xl;
    display: contents;
  }

  &_xl {
    @extend .height_4xl;
    @extend .width_4xl;
    display: contents;
  }

  &_lg {
    @extend .height_3xl;
    @extend .width_3xl;
    display: contents;
  }

  &_md {
    @extend .height_2xl;
    @extend .width_2xl;
    display: contents;
  }

  &_sm {
    @extend .height_lg;
    @extend .width_lg;
    display: contents;
  }

  &_xs {
    @extend .height_md;
    @extend .width_md;
    display: contents;
  }

  &_inner {
    &--empty {
      @extend .border_stroke_md;
      border-color: map-get($basic, "white");
      @extend .border_rounded_total;
      position: relative;
      background: map-get($neutral, "neutral-300");
    }

    &_2xl {
      @extend .border_stroke_md;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 48px;
    }

    &_xl {
      @extend .height_lg;
      @extend .width_lg;
      @extend .border_stroke_sm_df;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 24px;
    }

    &_lg {
      @extend .height_md;
      @extend .width_md;
      @extend .border_stroke_sm_df;
      border-radius: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 24px;
    }

    &_md {
      @extend .height_md;
      @extend .width_md;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 20px;
    }

    &_sm {
      @extend .height_sm;
      @extend .width_sm;
      @extend .border_stroke_sm_df;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 14px;
    }

    &_xs {
      height: 12px;
      width: 12px;
      @extend .border_stroke_sm_df;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 10px;
    }
  }

  &_connected {
    position: relative;

    &_2xl {
      @extend .height_2xl;
      @extend .width_2xl;
      @extend .margin-bottom_5xl;
      @extend .border_rounded_total;
      background-color: map-get($primary, "purple-500") !important;
      position: absolute;
      top: -6px;
      left: -6px;
      z-index: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      align-content: center;
    }

    &_xl {
      @extend .height_xl;
      @extend .width_xl;
      @extend .margin-bottom_xl;
      @extend .border_rounded_total;
      background-color: map-get($primary, "purple-500") !important;
      position: absolute;
      top: -16px;
      left: -16px;
      z-index: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      align-content: center;
    }

    &_lg {
      @extend .height_lg;
      @extend .width_lg;
      @extend .margin-bottom_md;
      @extend .border_rounded_total;
      background-color: map-get($primary, "purple-500") !important;
      position: absolute;
      top: -10px;
      left: -10px;
      z-index: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      align-content: center;
    }

    &_md {
      @extend .height_md;
      @extend .width_md;
      @extend .margin-bottom_md;
      @extend .border_rounded_total;
      background-color: map-get($primary, "purple-500") !important;
      position: absolute;
      top: -6px;
      left: -6px;
      z-index: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      align-content: center;
    }

    &_sm {
      @extend .height_sm;
      @extend .width_sm;
      @extend .margin-bottom_sm;
      @extend .border_rounded_total;
      background-color: map-get($primary, "purple-500") !important;
      position: absolute;
      top: -4px;
      left: -4px;
      z-index: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      align-content: center;

      .iconn_svg {
        margin-top: -16px;
      }
    }

    &_xs {
      @extend .height_xs-df;
      @extend .width_xs-df;
      @extend .margin-bottom_xs-df;
      @extend .border_rounded_total;
      background-color: map-get($primary, "purple-500") !important;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      align-content: center;

      .iconn_svg {
        margin-top: -31px;
      }
    }
  }

  &_secondary {
    &_2xl {
      @extend .margin-top_5xl;
      @extend .border_stroke_md;
      position: absolute;
      z-index: 1;
      font-size: 24px;

      &_second {
        @extend .margin-bottom_md;
        @extend .border_stroke_sm_df;
        position: absolute;
        z-index: 1;
        font-size: 24px;
      }
    }

    &_xl {
      @extend .margin-top_lg;
      @extend .border_stroke_sm_df;
      position: absolute;
      z-index: 1;
      font-size: 14px;

      &_second {
        @extend .margin-bottom_sm;
        @extend .border_stroke_sm_df;
        position: absolute;
        z-index: 1;
        font-size: 14px;
      }
    }

    &_lg {
      @extend .margin-top_md;
      @extend .border_rounded_total;
      @extend .border_stroke_sm_df;
      position: absolute;
      z-index: 1;
      font-size: 10px;

      &_second {
        @extend .margin-bottom_sm;
        @extend .border_stroke_sm_df;
        position: absolute;
        z-index: 1;
        font-size: 10px;
      }
    }

    &_md {
      @extend .margin-top_md;
      @extend .border_stroke_sm_df;
      position: absolute;
      z-index: 1;
      font-size: 10px;

      &_second {
        @extend .margin-bottom_xs-df;
        @extend .border_stroke_sm_df;
        position: absolute;
        z-index: 1;
        font-size: 10px;
      }
    }

    &_sm {
      @extend .margin-top_sm;
      @extend .border_stroke_sm_df;
      position: absolute;
      z-index: 1;
      font-size: 6px;

      &_second {
        @extend .margin-bottom_xs-df;
        @extend .border_stroke_sm_df;
        position: absolute;
        z-index: 1;
        font-size: 6px;
      }
    }

    &_xs {
      @extend .margin-top_xs-df;
      @extend .border_stroke_sm_df;
      position: absolute;
      z-index: 1;
      font-size: 4px;

      &_second {
        margin-bottom: 4px;
        @extend .border_stroke_sm_df;
        position: absolute;
        z-index: 1;
        font-size: 4px;
      }
    }
  }

  &_group {
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;

    &--item{
      flex-grow: 1;
      flex-basis: 50%;

      > div {
        display: flex;
        justify-content: center;
      }
    }

    &_2xl {
      @extend .height_4xl;
      @extend .width_4xl;
      @extend .border_stroke_md;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 24px;

      &--container{
        width: 128px;
        height: 128px;
      }
    }

    &_xl {
      @extend .height_lg;
      @extend .width_lg;
      @extend .border_stroke_sm_df;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 14px;

      &--container{
        @extend .width_4xl;
        @extend .height_4xl;
      }
    }

    &_lg {
      @extend .height_md;
      @extend .width_md;
      @extend .border_stroke_sm_df;
      border-radius: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 10px;

      &--container{
        @extend .width_2xl;
        @extend .height_2xl;
      }
    }

    &_md {
      @extend .height_md;
      @extend .width_md;
      @extend .border_stroke_sm_df;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 10px;

      &--container{
        @extend .width_2xl;
        @extend .height_2xl;
      }
    }

    &_sm {
      @extend .height_sm;
      @extend .width_sm;
      @extend .border_stroke_sm_df;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 6px;

      &--container{
        @extend .width_lg;
        @extend .height_lg;
      }
    }

    &_xs {
      height: 12px;
      width: 12px;
      @extend .border_stroke_sm_df;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 4px;

      &--container{
        @extend .width_md;
        @extend .height_md;
      }
    }
  }
}
</style>
